import classes from "./style.module.scss"

const Grid = () => {
    return (
        <div className={classes.grid}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    )
}

export default Grid